import { render, staticRenderFns } from "./ChampionshipFutureSiteCard.vue?vue&type=template&id=bd83336e&scoped=true&"
import script from "./ChampionshipFutureSiteCard.vue?vue&type=script&lang=js&"
export * from "./ChampionshipFutureSiteCard.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipFutureSiteCard.vue?vue&type=style&index=0&id=bd83336e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd83336e",
  null
  
)

export default component.exports